import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField'
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm } from 'devextreme/ui/dialog';
import { getApiErrorMessage, CONCURRENCY_HANDLED } from '../../../common/concurrency';
import { MESSAGES } from '../../../common/Messages';
import Toolbar, { Item } from "devextreme-react/toolbar";

import { GetFormatedDateWithTime, FormatPhoneNumber } from '../../../common/Utils'
import HeaderFrom from "../../common/HeaderFrom";
//import AdditionalTab from "../../wm/codes/customerDataEntry/AdditionalTab";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';

import ArrayStore from 'devextreme/data/array_store';
import { v4 as uuidv4 } from 'uuid';
import AddressTab from "../../common/AddressTab";
import AlternateAddressTab from "../../common/AlternateAddressTab";
import MasterDataTab from "../../common/MasterDataTab";
import RelationshipLinkList from "../../common/lists/RelationshipLinkList";
import Synonym from "../../common/Synonym";
import UserDefinedTab from "./tabs/UserDefinedTab";
import AdditionalTab from "./tabs/AdditionalTab";
import FrghtRateZonesTab from "./tabs/FrghtRateZonesTab";
import OMDefaultsTab from "./tabs/OMDefaultTab";
import EdiDefaultTab from "./tabs/EdiDefaultTab";
import WMDefaultTab from "./tabs/WMDefaultTab";



var skipDataLoading = false;

function Form(props) {

    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'ID',
        RECORDTYPE: 'R',
        IDENTITYID: '',
        NAME: '',
        R_DEFAULTADDRESS: null,
        INVISIBLETYPEGUID: '',
        R_PROFILE: null,
        PROFILEGUID: '',
        PROFILECODE: '',
        IDGROUP: '',
        IDSUBGROUP: '',
        REFERENCE1: '',
        REFERENCE2: '',
        DATE1: null,
        DATE2: null,
        R_CONTACT: null,
        COMMENT: '',
        R_IDENTITY: null,

        AddressROWID: '00000000-0000-0000-0000-000000000000',
        AddressCREATIONDATETIME: new Date(),
        AddressLASTUPDATEDATETIME: new Date(),
        AddressADDRESSNAME: '',
        AddressADDRESS1: '',
        AddressADDRESS2: '',
        AddressCITY: '',
        AddressZIP: '',
        AddressCOUNTRY: '',
        AddressTELEPHONE1: '',
        AddressTELEPHONE2: '',
        AddressFAX1: '',
        AddressFAX2: null,
        AddressMODEM1: '',
        AddressMODEM2: '',
        AddressCELLPHONE1: null,
        AddressCELLPHONE2: null,
        AddressPAGER1: null,
        AddressPAGER2: '',
        AddressEMAILADDRESS1: '',
        AddressEMAILADDRESS2: '',
        AddressWEBSITEADDRESS1: '',
        AddressWEBSITEADDRESS2: '',
        AddressSTATE: '',
        AddressALTERNATENAME: '',
        AddressLATITUDE: '',
        AddressLONGITUDE: '',
        AddressCOUNTY: '',

        AlterAddressROWID: '00000000-0000-0000-0000-000000000000',
        AlterAddressCREATIONDATETIME: new Date(),
        AlterAddressLASTUPDATEDATETIME: new Date(),
        AlterAddressNAME: '',
        AlterAddressADDRESSNAME: '',
        AlterAddressADDRESS1: '',
        AlterAddressADDRESS2: '',
        AlterAddressCITY: '',
        AlterAddressZIP: '',
        AlterAddressCOUNTRY: '',
        AlterAddressTELEPHONE1: '',
        AlterAddressTELEPHONE2: '',
        AlterAddressFAX1: '',
        AlterAddressFAX2: null,
        AlterAddressMODEM1: '',
        AlterAddressMODEM2: '',
        AlterAddressCELLPHONE1: null,
        AlterAddressCELLPHONE2: null,
        AlterAddressPAGER1: null,
        AlterAddressPAGER2: '',
        AlterAddressEMAILADDRESS1: '',
        AlterAddressEMAILADDRESS2: '',
        AlterAddressWEBSITEADDRESS1: '',
        AlterAddressWEBSITEADDRESS2: '',
        AlterAddressSTATE: '',
        AlterAddressALTERNATENAME: '',
        AlterAddressLATITUDE: '',
        AlterAddressLONGITUDE: '',
        AlterAddressCOUNTY: '',
        DefAddress: true,
        RECORD: '',

        WarehouseSTATUS: 'A',
        WarehouseROWID: '00000000-0000-0000-0000-000000000000',
        WarehouseCREATIONDATETIME: new Date(),
        WarehouseLASTUPDATEDATETIME: new Date(),
        WarehouseCOMMENT: null,
        WarehouseDIRECTIONS: null,
        WarehouseCOMPANYID: '',
        WarehouseMODULE: 'ID',
        WarehouseRECORDTYPE: 'R',
        WarehouseLOCATION: null,
        WarehouseSCACCODE: null,
        WarehouseFMSTOPNO: null,
        WarehouseDELIVERYROUTE: null,
        WarehousePOPUPMESSAGE: null,
        WarehouseUSERDEFINEDCODE_1: null,
        WarehouseUSERDEFINEDCODE_2: null,
        WarehouseUSERDEFINEDCODE_3: null,
        WarehouseUSERDEFINEDCODE_4: null,
        WarehouseUSERDEFINEDCODE_5: null,
        WarehouseUSERDEFINEDCODE_6: null,
        WarehouseUSERDEFINEDCODE_7: null,
        WarehouseUSERDEFINEDCODE_8: null,
        WarehouseUSERDEFINEDCODE_9: null,
        WarehouseUSERDEFINEDCODE_10: null,
        WarehouseUSERDEFINEDREFERENCE_1: null,
        WarehouseUSERDEFINEDREFERENCE_2: null,
        WarehouseUSERDEFINEDREFERENCE_3: null,
        WarehouseUSERDEFINEDREFERENCE_4: null,
        WarehouseUSERDEFINEDREFERENCE_5: null,
        WarehouseUSERDEFINEDREFERENCE_6: null,
        WarehouseUSERDEFINEDREFERENCE_7: null,
        WarehouseUSERDEFINEDREFERENCE_8: null,
        WarehouseUSERDEFINEDREFERENCE_9: null,
        WarehouseUSERDEFINEDREFERENCE_10: null,
        WarehouseUSERDEFINEDDATE_1: null,
        WarehouseUSERDEFINEDDATE_2: null,
        WarehouseUSERDEFINEDDATE_3: null,
        WarehouseUSERDEFINEDDATE_4: null,
        WarehouseUSERDEFINEDDATE_5: null,
        WarehouseUSERDEFINEDDATE_6: null,
        WarehouseUSERDEFINEDDATE_7: null,
        WarehouseUSERDEFINEDDATE_8: null,
        WarehouseUSERDEFINEDDATE_9: null,
        WarehouseUSERDEFINEDDATE_10: null,
        WarehouseUSERDEFINEDCOMMENT: '',
        WarehouseUSERDEFINEDQUANTITY_1: null,
        WarehouseUSERDEFINEDQUANTITY_2: null,
        WarehouseUSERDEFINEDQUANTITY_3: null,
        WarehouseUSERDEFINEDQUANTITY_4: null,
        WarehouseUSERDEFINEDQUANTITY_5: null,
        WarehouseUSERDEFINEDQUANTITY_6: null,
        WarehouseUSERDEFINEDQUANTITY_7: null,
        WarehouseUSERDEFINEDQUANTITY_8: null,
        WarehouseUSERDEFINEDQUANTITY_9: null,
        WarehouseUSERDEFINEDQUANTITY_10: null,
        WarehouseSOINVENTORYPRICELEVEL: null,
        WarehouseRPRICESCHEDULE: null,
        WarehouseRSHIPVIA: null,
        WarehouseRPARTICIPANT: null,
        WarehouseRPRODUCTCATEGORY: null,
        WarehouseRTAX: null,
        WarehouseRDEPARTMENT: null,
        WarehouseRFUND: null,
        WarehouseRJOB: null,
        WarehouseOMVISIBLE: null,
        WarehouseRWHITEM: null,
        WarehouseRWHLOCATION: null,
        WarehouseCONSIGNMENTUNITS: null,
        WarehouseRCONSIGNMENTPRODUCTCATEGORY: null,
        WarehouseRTRADINGPARTNER: null,
        WarehouseIDQUALIFIER: null,
        WarehouseIDCODE: null,
        WarehouseLOCATIONQUALIFIER: null,
        WarehouseLOCATIONIDENTIFIER: null,
        WarehouseWMEXPIRATIONDAYS: null,
        IDTYPE:"06",
        WarehouseRWEEKSETTINGS:null,
        WarehouseREXCEPTIONS:null,
    };
    const history = useHistory();
    const IdType = "06";
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);

    const [omDefaultRef, setOmDefaultRef] = useState(null);
    const [reportFormats, setReportFormats] = useState({ pickingSlipFormat: '', InvoiceFormat: '', OrderAcknFormat: '' });


    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    let warehouseRowId = null;
    let addressId = null;
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await postTransaction();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const postTransaction = async () => {
        try {
            const url = "id/Warehouse/InsertWarehouse";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.RECORDTYPE = 'R';
            fields.WarehouseUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_1);
            fields.WarehouseUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_2);
            fields.WarehouseUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_3);
            fields.WarehouseUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_4);
            fields.WarehouseUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_5);
            fields.WarehouseUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_6);
            fields.WarehouseUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_7);
            fields.WarehouseUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_8);
            fields.WarehouseUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_9);
            fields.WarehouseUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_10);
            fields.WarehouseUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_11);
            fields.WarehouseUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_12);
            fields.WarehouseUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_13);
            fields.WarehouseUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_14);
            fields.WarehouseUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_15);
            fields.WarehouseUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_16);
            fields.WarehouseUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_17);
            fields.WarehouseUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_18);
            fields.WarehouseUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_19);
            fields.WarehouseUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_20);
            fields.IDTYPE='06';
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                addressId = response.data.AddressROWID;
                warehouseRowId = response.data.EntityROWID;
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD,
                    R_IDENTITY: response.data.ROWID,
                    AddressROWID: response.data.AddressROWID,
                    R_DEFAULTADDRESS: response.data.AddressROWID,
                    WarehouseROWID: response.data.EntityROWID,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Warehouse Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "id/Warehouse/UpdateWarehouse";
            let fields = formFields;
            fields.DefAddress = fields.DefAddress ?? true;
            if (fields.AlterAddressROWID === null)
                fields.AlterAddressROWID = initialFormFields.AlterAddressROWID;

            fields.DATE1 = GetFormatedDateWithTime(formFields.DATE1);
            fields.DATE2 = GetFormatedDateWithTime(formFields.DATE2);
            fields.WarehouseUSERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_1);
            fields.WarehouseUSERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_2);
            fields.WarehouseUSERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_3);
            fields.WarehouseUSERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_4);
            fields.WarehouseUSERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_5);
            fields.WarehouseUSERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_6);
            fields.WarehouseUSERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_7);
            fields.WarehouseUSERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_8);
            fields.WarehouseUSERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_9);
            fields.WarehouseUSERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_10);
            fields.WarehouseUSERDEFINEDDATE_11 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_11);
            fields.WarehouseUSERDEFINEDDATE_12 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_12);
            fields.WarehouseUSERDEFINEDDATE_13 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_13);
            fields.WarehouseUSERDEFINEDDATE_14 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_14);
            fields.WarehouseUSERDEFINEDDATE_15 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_15);
            fields.WarehouseUSERDEFINEDDATE_16 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_16);
            fields.WarehouseUSERDEFINEDDATE_17 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_17);
            fields.WarehouseUSERDEFINEDDATE_18 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_18);
            fields.WarehouseUSERDEFINEDDATE_19 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_19);
            fields.WarehouseUSERDEFINEDDATE_20 = GetFormatedDateWithTime(formFields.WarehouseUSERDEFINEDDATE_20);
            fields.IDTYPE='06';
            if (addressId !== null) { fields.AddressROWID = addressId; }
            if (warehouseRowId !== null) { fields.WarehouseROWID = warehouseRowId; }

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    AlterAddressROWID: response.data.AlterAddressROWID,
                }));
                notify(
                    {
                        message: "Warehouse Data Entry Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            } else {
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = (formRefs) => {
        primaryFormLoad(formRefs);
        additionalFormLookupsLoad(formRefs);
        omDefaultsFormLookupsLoad(formRefs);
    }
    const additionalFormLookupsLoad = (formRefs) => {
        const groupLoadParams = {
            codeType: '01',
        };
        const settlementgroupLoadParams = {
            codeType: 'AC',
        };
        const serviceParams = {
            codeType: 'PS',
        };
        loadLookupFromDataSource(formRefs, "CustomerR_TERMS", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTerms}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_TAXCODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_TAXCODE2", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTax}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerBILLINGCYCLE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', groupLoadParams);
        loadLookupFromDataSource(formRefs, "CustomerR_GLDEPARTMENT", `${window._env_.REACT_APP_APIS}/${data.AC.GetDepartments}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_GLFUND", `${window._env_.REACT_APP_APIS}/${data.FA.GetFafunds}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_CAJOB", `${window._env_.REACT_APP_APIS}/${data.CA.GetCaJobs}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_TRADINGPARTNER", `${window._env_.REACT_APP_APIS}/${data.ID.GetTradePartner}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerR_SERVICESPRICING", `${window._env_.REACT_APP_APIS}/${data.ID.GetServicePricing}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerPOPUPMESSAGE", `${window._env_.REACT_APP_APIS}/${data.AB.GetPopupMessages}`, 'name', 'name');
        loadLookupFromDataSource(formRefs, "CustomerSETTLEMENTPAYGROUP", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', settlementgroupLoadParams);
        loadLookupFromDataSource(formRefs, "CustomerR_CASHRECEIPTSPORFILE", `${window._env_.REACT_APP_APIS}/${data.AR.GetArCashReceiptsDp}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerARACCOUNT", `${window._env_.REACT_APP_APIS}/${data.AC.GetAcAccounts}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerSHIPSERVICECODE", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`, 'name', 'name', serviceParams);

        loadLookupFromStaticData(formRefs, "CustomerLOTEXPIRATIONDATECHECK", [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }]);
        loadLookupFromStaticData(formRefs, "CustomerSHIPSERVICELEVEL", [{ id: 'A', name: "Autodetect" }, { id: 'B', name: "Ship Crates" }, { id: 'C', name: "Ship Serial numbers" }, { id: 'D', name: "Ship Sublots" }]);
        loadLookupFromStaticData(formRefs, "CustomerSTATUS", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
        loadLookupFromStaticData(formRefs, "CustomerSMINVOICEEMAIL", [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }]);
        loadLookupFromDataSource(formRefs, "CustomerR_AROPENITEMDP", `${window._env_.REACT_APP_APIS}/${data.AR.GetArOpenItemDp}`, 'id', 'name');


    };
    const userDefinedFormLookupsLoad = (formRefs) => {

    };
    const additonalFormLookupsLoad = (formRefs) => {
        loadLookupFromStaticData(formRefs, "WarehouseSTATUS", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
    };
    const primaryFormLoad = (formRefs) => {

        if (formRefs.current['RECORD']) {
            formRefs.current['RECORD'].instance().option('disabled', true);
        }
    }
    const oMDefaultsSelectionChanged = (formRefs, name, value, text = null, formatCaption = null, chargeuom = null) => {

    }
    const omDefaultsFormLookupsLoad = (formRefs) => {
        const priceLevels = [{ id: 'A', name: "Price Level - A" }, { id: 'B', name: "Price Level - B" }, { id: 'C', name: "Price Level - C" }, { id: 'D', name: "Price Level - D" }, { id: 'E', name: "Price Level - E" },
        { id: 'F', name: "Price Level - F" }, { id: 'G', name: "Price Level - G" }, { id: 'H', name: "Price Level - H" }, { id: 'I', name: "Price Level - I" }, { id: 'J', name: "Price Level - J" }, { id: 'K', name: "Price Level - K" }, { id: 'L', name: "Price Level - L" }, { id: 'M', name: "Price Level - M" },
        { id: 'N', name: "Price Level - N" }, { id: 'O', name: "Price Level - O" }, { id: 'P', name: "Price Level - P" }, { id: 'Q', name: "Price Level - Q" }, { id: 'R', name: "Price Level - R" },
        { id: 'S', name: "Price Level - S" }, { id: 'T', name: "Price Level - T" }, { id: 'U', name: "Price Level - U" }, { id: 'V', name: "Price Level - V" }, { id: 'X', name: "Price Level - X" },
        { id: 'Y', name: "Price Level - Y" }, { id: 'Z', name: "Price Level - Z" }
        ];
        const yesNo = [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }];
        loadLookupFromStaticData(formRefs, "WarehouseOMVISIBLE", yesNo);
        const convertUnitsOptions = [{ id: 'P', name: "To Pieces" }, { id: 'N', name: "No" }];
        loadLookupFromStaticData(formRefs, "WarehouseCONSIGNMENTUNITS", convertUnitsOptions);
        loadLookupFromStaticData(formRefs, "WarehouseSOINVENTORYPRICELEVEL", priceLevels);
        setOmDefaultRef(formRefs);
    }

    const loadLookupFromCodesDataSource = (formRefs, type, name) => {
        const dataSource = GetCodeByType(type);
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
            formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const GetCodeByType = (type) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetIDCodes}`,
                key: 'name',
                loadParams: {
                    codeType: type,
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    const loadLookupFromDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };



    const handleReset = () => {

        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.ID.DeleteCustomerDataEntry}`, formFields.ROWID, {
                    headers: {
                        'Content-Type': 'application/json',
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
                if (!response.data.ERRORS.length > 0) {
                    notify(
                        {
                            message: "Warehouse Deleted",
                            width: 100,
                        },
                        'success',
                        3000,
                    );
                    setLoadPanelVisible(false);
                    history.push('/wm/codes/Warehouse-data-entry');
                } else {
                    setLoadPanelVisible(false);
                    const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
            }
        })
    }
    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/codes/add-Warehouse');
        EnableControlsForNewRecord();
    }

    // The record load. Previously the axios promise had no .catch, so an HTTP failure became an
    // unhandled rejection: no message anywhere and a blank form. The surrounding try/catch could not
    // help — it only covers the synchronous call — and `finally` ran immediately, hiding the load
    // panel on a 1s timer rather than when the request actually finished.
    const GetHeaderInfoById = (id) => {
        setLoadPanelVisible(true);

        axios.get(`${window._env_.REACT_APP_APIS}/${data.ID.GetWarehouseDataByRowId}?rowid=${id}`, {
            headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`
            }
        })
            .then((res) => {
                const responseData = res.data;
                if (responseData && responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (formRefs.current["R_PROFILE"]) {
                        const profileWidget = formRefs.current["R_PROFILE"].instance();
                        if (profileWidget) {
                            profileWidget.option('disabled', true);
                        }
                    }
                }
                else {
                    // A 200 with no record: the row is not visible, not this company's, or not an
                    // 'R'/'Z' record type. Say so instead of leaving the form silently blank.
                    console.error('GetWarehouseDataByRowId returned no record for rowid', id, responseData);
                    alert(MESSAGES.RECORD_NOT_FOUND, MESSAGES.ERROR);
                }
            })
            .catch((error) => {
                console.error('GetWarehouseDataByRowId failed for rowid', id, {
                    httpStatus: error?.response?.status,
                    responseBody: error?.response?.data,
                    message: error?.message,
                });
                if (error?.[CONCURRENCY_HANDLED]) return;
                alert(getApiErrorMessage(error, MESSAGES.ERROR), MESSAGES.ERROR);
            })
            .finally(() => {
                hideLoadPanel();
            });
    };

    // Keyed on the id and the token rather than running once on mount. With [] deps the single run
    // was spent whether or not those were available yet: on a direct page load the route can render
    // before the id is parsed or before redux-oidc has hydrated the user, and the record then never
    // loaded because the effect never ran again. Also re-loads when the id changes without a
    // remount, e.g. moving straight from one warehouse to another.
    useEffect(() => {
        const rowid = props.id;
        if (rowid == null || rowid === undefined || rowid === '') return;
        if (!accessToken) return;

        GetHeaderInfoById(rowid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.id, accessToken]);

    const goBack = () => {
        history.push("/wm/codes/warehouse-data-entry");
    };

    const EnableControlsForNewRecord = () => {

        if (formRefs.current["R_PROFILE"]) {
            formRefs.current["R_PROFILE"].instance().option('disabled', false);
        }

        if (formRefs.current["R_CUSTOMER"]) {
            formRefs.current["R_CUSTOMER"].instance().option('disabled', false);
        }

        if (formRefs.current["TRANSACTIONTYPE"]) {
            formRefs.current["TRANSACTIONTYPE"].instance().option('disabled', false);
        }
    }

    const GetCustomerDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.ID.GetWarehouseDataByRowId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data) {
                    let responseData = response.data
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.AlterAddressROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.WarehouseROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.AlterAddressCREATIONDATETIME = null;
                    responseData.AddressLASTUPDATEDATETIME = null;
                    responseData.AddressCREATIONDATETIME = null;
                    responseData.WarehouseCREATIONDATETIME = null;
                    responseData.WarehouseLASTUPDATEDATETIME = null;

                    responseData.CREATIONUSERID = '';
                    responseData.LASTUPDATEUSERID = '';
                    responseData.COMPANYID = '';
                    responseData.MODULE = 'ID';
                    responseData.RECORDTYPE = 'R';
                    responseData.IDTYPE="06";
                    setformFields(responseData);
                }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_PROFILE" && !skipDataLoading) {
            GetCustomerDataFromProfile(value);
        }
    });
    const getFormats = () => {
        let SReport = '';
        if (reportFormats.pickingSlipFormat !== '') {
            if (formFields.CustomerOMPICKINGSLIPREPORTTYPE === 'C') {
                let f = reportFormats.pickingSlipFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.pickingSlipFormat + '\r\n';
            }
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormats.InvoiceFormat !== '') {
            if (formFields.CustomerOMINVOICEREPORTTYPE === 'C') {
                let f = reportFormats.InvoiceFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.InvoiceFormat + '\r\n';
            }
        }
        else {
            SReport += '\r\n';
        }
        if (reportFormats.OrderAcknFormat !== '') {
            if (formFields.CustomerOMORDERACKNREPORTTYPE === 'C') {
                let f = reportFormats.OrderAcknFormat.split('||');
                SReport += f[2] + '\r\n';
            }
            else {
                SReport += reportFormats.OrderAcknFormat + '\r\n';
            }
        }
        return SReport;
    }

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Warehouse Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <HeaderFrom formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} primaryFormLookupsLoad={primaryFormLookupsLoad} IdType={IdType} />
                                </TabItem>
                                <TabItem title="Def Address" >
                                    <AddressTab formFields={formFields} setformFields={setformFields} />
                                </TabItem>
                                <TabItem title="Alternate Address" >
                                    <AlternateAddressTab formFields={formFields} setformFields={setformFields} IdType={IdType} />
                                </TabItem>
                                <TabItem title="Additional">
                                    <AdditionalTab formFields={formFields} setformFields={setformFields} additonalFormLookupsLoad={additonalFormLookupsLoad}/>
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab formFields={formFields} setformFields={setformFields} userDefinedFormLookupsLoad={userDefinedFormLookupsLoad} />
                                </TabItem>
                                <TabItem title="Contact" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="Contact"
                                        gridKey='275C96CD-E464-45E9-9B41-95E084F83D26' />
                                </TabItem>
                                <TabItem title="All Contacts" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <MasterDataTab RIDMaster={formFields.ROWID} IDType={IdType} IDMemeberType='22' TabName="AllContacts"
                                        gridKey='BCDFA379-D6D9-4B2F-8E9B-13896CE767EF' />
                                </TabItem>
                                <TabItem title="Customer" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <RelationshipLinkList gridKey="9309CA0F-2521-4108-9811-EA067C03BFF4" formFields={formFields} IdMemberType={IdType} IdMasterType={IdType} LookupUrl="id/Lookup/GetCustomers" Editable={true}/>
                                </TabItem>
                                <TabItem title="Synonyms" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <Synonym gridKey="F105A7EB-5B31-4E9D-9DD0-21FD290B4246" formFields={formFields} IdType={IdType}></Synonym>
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
